import L from "leaflet";

// Munich city center — matches the typical business catchment area.
export const DEFAULT_CENTER = [48.1351, 11.582];
export const DEFAULT_ZOOM = 9;
export const OSM_TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// Build a Leaflet divIcon for a given hex color. The SVG reproduces the
// classic Leaflet teardrop pin (25x41) so we keep the familiar shape but
// recolor the fill per marker category. Memoized per color so Leaflet isn't
// rebuilding the same icon on every render.
const iconCache = new Map();
export const getColoredIcon = (color) => {
  if (iconCache.has(color)) return iconCache.get(color);
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" ` +
    `style="filter: drop-shadow(0 2px 2px rgba(0,0,0,0.4));">` +
    `<path d="M12.5 0.5C5.873 0.5 0.5 5.873 0.5 12.5c0 8.5 12 28 12 28s12-19.5 12-28` +
    `C24.5 5.873 19.127 0.5 12.5 0.5z" fill="${color}" stroke="#fff" stroke-width="1.2"/>` +
    `<circle cx="12.5" cy="12.5" r="4.5" fill="#fff"/>` +
    `</svg>`;
  const icon = L.divIcon({
    className: "",
    html: svg,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -36],
  });
  iconCache.set(color, icon);
  return icon;
};
